import { TextAreaBaseCustomElement } from 'General/Resources/Elements/TextArea/TextAreaBase';
import { customElement } from 'aurelia-framework';

@customElement('text-area')
export class TextAreaSimpleTextCustomElement extends TextAreaBaseCustomElement {}